export const MOBILE_SCANS_LIST_FALLBACK_QUERY = `
	query MobileScansListFallback(
		$runId: ConditionID!
		$textSearch: issuesSearchInsensitive
		$severityIdFilter: ConditionString
		$typeIdFilter: ConditionString
		$scanNameFilter: ConditionString
	) {
		issues(
			run_id_eq: $runId
			text_contains: $textSearch
			severity_name_eq: $severityIdFilter
			type_name_eq: $typeIdFilter
			scan_name_eq: $scanNameFilter
			deleted_eq: { value: false }
		) {
			issue_id
			product_name
			run_id
			scan_id
			scan_name
			screenshot
			severity_name
			elements__id
		}

		scans(run_id_eq: $runId) {
			scan_id
			created_at
		}
	}
`;
